import { Instagram, Youtube, Mail, ArrowUpRight } from "lucide-react";
import { LINKS } from "../../lib/links";

const SOCIAL = [
  { icon: Instagram, label: "Instagram", href: LINKS.instagram, id: "instagram" },
  { icon: Youtube, label: "YouTube", href: LINKS.youtube, id: "youtube" },
  { icon: Mail, label: "Email", href: LINKS.email, id: "email" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-zinc-900 pt-24 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          {/* Wordmark + tagline */}
          <div className="md:col-span-6">
            <a
              href="#top"
              className="block text-3xl md:text-5xl tracking-tighter font-extrabold text-white"
              data-testid="footer-logo"
            >
              JORDAN<span className="text-zinc-600">.</span>YOUNG
            </a>
            <p className="mt-6 max-w-md text-sm md:text-base text-zinc-500 leading-relaxed">
              Entrepreneur, mentor and founder of Find My Filmmaker. Based in
              London. Currently mentoring builders through The Builder
              Programme.
            </p>
          </div>

          {/* Navigate */}
          <div className="md:col-span-3">
            <h4 className="text-xs tracking-[0.3em] uppercase text-zinc-500 font-bold mb-5">
              Navigate
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Story", href: "#story" },
                { label: "Programme", href: "#programme" },
                { label: "Apply", href: "#apply" },
                { label: "Resources", href: "#resources" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-zinc-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div className="md:col-span-3">
            <h4 className="text-xs tracking-[0.3em] uppercase text-zinc-500 font-bold mb-5">
              Connect
            </h4>
            <ul className="space-y-3">
              {SOCIAL.map((s) => {
                const Icon = s.icon;
                return (
                  <li key={s.label}>
                    <a
                      href={s.href}
                      target={s.id === "email" ? undefined : "_blank"}
                      rel="noopener noreferrer"
                      data-testid={`footer-social-${s.id}`}
                      className="group inline-flex items-center gap-3 text-sm text-zinc-300 hover:text-white transition-colors"
                    >
                      <Icon className="w-4 h-4" strokeWidth={1.6} />
                      <span>{s.label}</span>
                    </a>
                  </li>
                );
              })}
              <li>
                <a
                  href={LINKS.stanStore}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-social-stan-store"
                  className="group inline-flex items-center gap-3 text-sm text-zinc-300 hover:text-white transition-colors"
                >
                  <ArrowUpRight className="w-4 h-4" strokeWidth={1.6} />
                  <span>Stan Store</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-zinc-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs tracking-[0.2em] uppercase text-zinc-600 font-bold">
            © {new Date().getFullYear()} Jordan Young. All rights reserved.
          </p>
          <p className="text-xs tracking-[0.2em] uppercase text-zinc-600 font-bold">
            Designed in London · Built for Builders
          </p>
        </div>
      </div>
    </footer>
  );
};
